/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true, todo: true */

"use strict";

var ko = require("knockout");

var pli = require("../core");
var $ = require("../jquery");
var activateStopBinding = require("../knockout/stopBinding").activateStopBinding;
var crumbIdUtil = require("../util/crumbId");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Side-effect imports and functions
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

require("jquerytools"); // defines $.mask and $.overlay

// This is needed because the "stopBinding" knockout binding is used in _FormsTemplate.cshtml
activateStopBinding();



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var rootForm = null,
    lastActiveElement = null,
    crumbsListBegin = null, // the first navigation crumb in the current crumbs linked list
    crumbsListEnd = null, // the last navigation crumb in the current crumbs linked list
    formsRegistry = {},
    navigationPages = {};


//-------------------------------------------
function rewriteHrefs(navigationPage, hash, isDisabled) {
    /// <summary>
    /// Re-writes the href attribute with the correct hash.
    /// href is removed for those pages that are disabled or
    /// have a parent page that is disabled.
    /// </summary>
    var i, p, d = isDisabled || navigationPage.isDisabled;

    navigationPage.activationHash = hash; // store the hash at the page level for re-writing urls when enabling/disabling a page.

    if (!navigationPage.$activatedBy) {
        navigationPage.$activatedBy = (navigationPage.activatedBy
            ? $(navigationPage.activatedBy)
            : $());
    }
    if (!navigationPage.$activationIndicatedBy) {
        navigationPage.$activationIndicatedBy = (navigationPage.activationIndicatedBy
            ? $(navigationPage.activationIndicatedBy)
            : navigationPage.$activatedBy);
    }

    if (d) {
        navigationPage.$activatedBy.removeAttr("href"); // IMPORTANT! don't use "removeProp" because it sets href to (string) "undefined", also don't use "prop('href', null)" because it doesn't work in IE; if the current page or a parent page is disabled remove the href attribute from all $activatedBy (this converts a hyperlink to a static text in all browsers)
    } else {
        navigationPage.$activatedBy.prop("href", hash); // otherwise set the current href property.
    }

    for (i = 0; i < navigationPage.children.length; i += 1) {
        p = navigationPage.children[i];
        rewriteHrefs(p, hash.concat("/", p.name), d); // recursive call (pass the disabled state to child controls).
    }
}


//-------------------------------------------
function validateNavigationData(lastData, newData) {
    /// <summary>
    /// Give client code a chance to mark the specified
    /// newData object as valid (via an event
    /// "pliInitializingFormData" on newData.form.$form).
    /// A valid data structure is considered one that
    /// contains a truthy value in either "value" or
    /// "call" property. Returns newData if validation
    /// succeeds, null otherwise.
    /// </summary>
    var e = new $.Event("pliInitializingFormData");
    if (lastData) { newData.previous = lastData; lastData.next = newData; } // connect newData to lastData (if any lastData)
    e.pli = { data: newData };
    newData.form.$form.trigger(e);

    if (!newData.value && !newData.call) { // if we didn't determine value right away and didn't start a PLI call to get the value, newData is not valid
        if (lastData) { newData.previous = null; lastData.next = null; } // disconnect newData from lastData (if any lastData)
        newData = null;
    }

    return newData;
}


//-------------------------------------------
function activateNavigationCrumbDefault(crumb) {
    /// <summary>
    /// </summary>
    var overlayApi, c, p, i, navigationPage = crumb.page;

    // if (window.console) { window.console.log("(activateNavigationCrumb) Showing \"".concat(crumb.hash, "\"", navigationPage.form ? " (with HREF rewrite)" : "").replace(/%/g, "^"), crumb); } // current chrome has issues logging '%' character, remove the 'replace' call once this is fixed
    if (navigationPage.keymap && pli.keys) {
        if (navigationPage.keymapIgnoreParents || (navigationPage.form && navigationPage.form.keymapIgnoreParents)) { pli.keys.activateKeymap(null); }
        pli.keys.activateKeymap(navigationPage.keymap);
    }
    if (navigationPage.form) {
        rewriteHrefs(navigationPage, crumb.hash); // creates navigationPage.$activatedBy for all descendant navigation pages
        if (!navigationPage.form.isRoot) {
            if (navigationPage.form.isModal) { // modal (popup) form uses jQuery Tools Overlay
                overlayApi = navigationPage.form.$form.data("overlay");
                if (!overlayApi) {
                    navigationPage.form.$form.overlay({
                        oneInstance: false,
                        left: "center",
                        top: "center",
                        speed: 150,
                        closeOnClick: false,
                        closeOnEsc: false,
                        closeSpeed: 0
                    });
                    overlayApi = navigationPage.form.$form.data("overlay");
                }

                overlayApi.load();

                // count number of crumbs from current "crumb" until beginning of the list
                // (in "previous" direction, includes the initial crumb)
                for (i = 1, c = crumb.previous; c; c = c.previous) {
                    p = p || (c.page === crumb.page ? c : null);
                    i += 1;
                }
                i = 1000 + (10 * i);
                navigationPage.form.$form.css("z-index", i);
                crumb.zIndex = i; // used by updateMaskPosition to move mask div just behind the last activated form (in z axis)

                // if this form is already open and "getFormState" defined
                // store the form state to restore later
                if (p && typeof navigationPage.form.getFormState === "function") {
                    p.formState = navigationPage.form.getFormState();
                }

            } else { // non-modal (inline) form
                navigationPage.$page.addClass("active");
            }
        }
    } else {
        navigationPage.$page.addClass("active");
    }

    navigationPage.$activationIndicatedBy.addClass("active");
    navigationPage.loadFocus();
}


//-------------------------------------------
function activateNavigationCrumbs(initialCrumb, activeElements) {
    /// <summary>
    /// </summary>
    var e, $p;

    if (initialCrumb && initialCrumb.previous) {
        initialCrumb.previous.page.saveFocus(activeElements);
    }
    while (initialCrumb) {
        $p = initialCrumb.page.$page;
        e = new $.Event("pliActivating");
        e.pli = { crumb: initialCrumb };
        $p.trigger(e);
        if (!e.isDefaultPrevented()) {
            activateNavigationCrumbDefault(initialCrumb);
            e = new $.Event("pliActivated");
            e.pli = { crumb: initialCrumb };
            $p.trigger(e);
        }
        initialCrumb = initialCrumb.next;
    }
}


//-------------------------------------------
function areCrumbsValidAndEquivalent(c1, c2) {
    /// <summary>
    /// Returns true if both c1 and c2 are valid
    /// crumbs (as opposed to null/undefined) and
    /// they are equivalent, false otherwise.
    /// Crumbs are considered equivalent if they
    /// either have exactly the same hash value
    /// (case insensitive) or of they point to
    /// the same form (i.e. the hashes only differ
    /// in form value part).
    /// </summary>
    if (!c1 || !c2) {
        return false;
    }

    if (c1.hash.toLowerCase() !== c2.hash.toLowerCase()) {
        if (!c1.page.form || !c2.page.form || c1.page.form !== c2.page.form) {
            return false;
        }
    }

    return true;
}


//-------------------------------------------
function areCrumbsSame(c1, c2) {
    return (c1 === c2 || (c1 && c2 && c1.inLocationHash && c2.inLocationHash && c1.hash.toLowerCase() === c2.hash.toLowerCase()));
}


//-------------------------------------------
function createNavigationCrumbDefault(hashSegment, currentCrumb) {
    /// <summary>
    /// </summary>
    var h, i, p, c, s, d = null, navigationPage = currentCrumb.page;

    if (hashSegment) {
        // are we transitioning to a child (inline) form?
        if (navigationPage.defaultChildFormId) {
            if (navigationPage.children.length > 0) { throw new Error("Navigation page \"".concat(navigationPage.id, "\" specifies a defaultChildFormId but also has child navigation pages (only one or the other is allowed)")); }
            d = {
                type: "PLI form data",
                form: pli.forms.registry[navigationPage.defaultChildFormId],
                id: crumbIdUtil.decode(hashSegment),
                rawId: hashSegment
            };
            if (!d.form) { throw new Error("Navigation page \"".concat(navigationPage.id, "\" specifies an unknown form \"", navigationPage.defaultChildFormId, "\" in defaultChildFormId")); }
        } else {
            s = hashSegment.split(':');
            if (s.length > 1) {
                if (s.length > 2) { throw new Error("Hash segment \"".concat(hashSegment, "\" contains more than 2 parts separated by ':'")); }
                d = {
                    type: "PLI form data",
                    form: pli.forms.registry[s[0]],
                    id: crumbIdUtil.decode(s[1])
                };
                if (!d.form) { throw new Error("Hash segment \"".concat(hashSegment, "\" specifies an unknown form \"", s[0], "\"")); }
            }
        }
        if (d) { // found a child form, let's create a crumb for it
            if (!d.form.page.isDisabled) { // only create a crumb if the form is not disabled
                c = currentCrumb;
                while (c) { // make sure the requested form is not yet shown
                    if (c.page.form && c.page.form.id === d.form.id) {
                        throw new Error("Form \"".concat(d.form.id, "\" is already shown, unable to show again"));
                    }
                    c = c.previous;
                }

                d = validateNavigationData(currentCrumb.data, d);
                if (d) {
                    c = {
                        type: "PLI navigation crumb",
                        page: d.form.page,
                        data: d,
                        inLocationHash: true,
                        hash: currentCrumb.hash.concat("/", hashSegment),
                        previous: currentCrumb
                    };
                    currentCrumb.next = c;
                    return c;
                }
            }
            return null;
        }

        // we have a segment, find first child page that matches the segment
        h = hashSegment.toLowerCase();
        for (i = 0; i < navigationPage.children.length; i += 1) {
            p = navigationPage.children[i];
            if (!p.isDisabled && p.name.toLowerCase() === h) {
                c = {
                    type: "PLI navigation crumb",
                    page: p,
                    data: currentCrumb.data,
                    inLocationHash: true,
                    hash: currentCrumb.hash.concat("/", hashSegment),
                    previous: currentCrumb
                };
                currentCrumb.next = c;
                return c;
            }
        }
    } else {
        // we don't have a hash segment, attempt to find default child navigation page
        for (i = 0; i < navigationPage.children.length; i += 1) {
            p = navigationPage.children[i];
            if (!p.isDisabled && p.isDefault) {
                c = {
                    type: "PLI navigation crumb",
                    page: p,
                    data: currentCrumb.data,
                    inLocationHash: false,
                    hash: currentCrumb.hash.concat("/", p.name),
                    previous: currentCrumb
                };
                currentCrumb.next = c;
                return createNavigationCrumbDefault(null, c) || c; // recursive call
            }
        }
    }

    return null;
}


//-------------------------------------------
function createNavigationCrumb(hashSegment, currentCrumb) {
    /// <summary>
    /// </summary>
    var c,
        $p = currentCrumb.page.$page,
        e = new $.Event("pliCreatingCrumb");
    e.pli = { hashSegment: hashSegment, currentCrumb: currentCrumb, crumb: null };
    $p.trigger(e);
    if (e.isDefaultPrevented()) {
        c = e.pli.crumb;
    } else { // if default action on pliCreatingCrumb event was not prevented, run default creation function
        c = createNavigationCrumbDefault(hashSegment, currentCrumb);
        e = new $.Event("pliCreatedCrumb");
        e.pli = { hashSegment: hashSegment, currentCrumb: currentCrumb, crumb: c };
        $p.trigger(e);
    }
    return c;
}


//-------------------------------------------
function deactivateNavigationCrumbDefault(crumb, activeCrumbsListEnd) {
    /// <summary>
    /// </summary>
    var navigationPage = crumb.page;

    // if (window.console) { window.console.log("(deactivateNavigationCrumb) Hiding \"".concat(crumb.hash, "\"").replace(/%/g, "^"), crumb); }
    if (navigationPage.keymap && pli.keys) {
        pli.keys.deactivateKeymap(navigationPage.keymap);
        if (navigationPage.keymapIgnoreParents || (navigationPage.form && navigationPage.form.keymapIgnoreParents)) { pli.keys.deactivateKeymap(null); }
    }
    navigationPage.$activationIndicatedBy.removeClass("active"); // "navigationPage.$activationIndicatedBy" is always present (created during activation)
    if (navigationPage.form) {
        if (!navigationPage.form.isRoot) {
            if (navigationPage.form.isModal) {

                // Check if another instance of this page was opened
                // (in "previous" direction, not including the initial crumb)
                var activeCrumbWithSamePage = activeCrumbsListEnd;
                while (activeCrumbWithSamePage) {
                    if (activeCrumbWithSamePage.page === navigationPage) { break; }
                    activeCrumbWithSamePage = activeCrumbWithSamePage.previous;
                }
                if (activeCrumbWithSamePage) {
                    navigationPage.form.$form.css("z-index", activeCrumbWithSamePage.zIndex); // restore previous z-index
                    if (typeof navigationPage.form.loadFormState === "function") { // restore form state (if supported)
                        navigationPage.form.loadFormState(activeCrumbWithSamePage.formState);
                        activeCrumbWithSamePage.formState = null;
                    }
                } else {
                    var overlayApi = navigationPage.form.$form.data("overlay");
                    if (overlayApi) { overlayApi.close(); }
                    navigationPage.forgetFocus();
                }

            } else { // non-modal (inline) form
                navigationPage.$page.removeClass("active");
            }
        }
    } else if (navigationPage.$page) {
        navigationPage.$page.removeClass("active");
    }
}


//-------------------------------------------
function deactivateNavigationCrumbs(initialCrumb, activeCrumbsListEnd) {
    /// <summary>
    /// </summary>
    var e, $p, activeElements = null;

    while (initialCrumb) {
        $p = initialCrumb.page.$page;
        e = new $.Event("pliDeactivating");
        e.pli = { crumb: initialCrumb };
        $p.trigger(e);
        if (!e.isDefaultPrevented()) {
            activeElements = initialCrumb.page.saveFocus(activeElements);
            deactivateNavigationCrumbDefault(initialCrumb, activeCrumbsListEnd);
            e = new $.Event("pliDeactivated");
            e.pli = { crumb: initialCrumb };
            $p.trigger(e);
        }
        initialCrumb = initialCrumb.previous;
    }

    return activeElements;
}


//-------------------------------------------
function normalizeNavigationHash(hash, toLowerCase) {
    /// <summary>
    /// Normalize the specified hash value (make
    /// sure it is a string, has no leading or
    /// trailing whitespace and no trailing slashes).
    /// The returned value can optionally be converted
    /// to lower case (if toLowerCase is a truthy
    /// value). Values "", "#" and "#/" will be
    /// normalized to "#".
    /// </summary>
    var i;
    if (hash === null) { // because of firefox bug, we can't use location.hash, so we will parse it out of href
        hash = location.href;
        i = hash.indexOf('#');
        hash = (i < 0 ? "" : hash.substring(i)); // include '#'
    }

    hash = $.trim(hash).replace(/\/+$/, ""); //remove leading/trailing whitespace + remove trailing slashes
    return (hash === ""
        ? "#"
        : toLowerCase
            ? hash.toLowerCase()
            : hash);
}


//-------------------------------------------
function getCurrentForm(includeInlineForms) {
    /// <summary>
    /// Return the form object for the currently
    /// active form (top of the stack of opened forms).
    /// </summary>
    var f, c = crumbsListEnd;
    while (c) {
        f = c.page.form;
        if (f && (includeInlineForms || f.isModal || f.isRoot)) {
            return f;
        }
        c = c.previous;
    }
    throw new Error("No current form found (should never happen)");
}


//-------------------------------------------
function isNoHashFormActive() {
    var c = crumbsListEnd;
    while (c) {
        if (!c.hash) {
            return true;
        }
        c = c.previous;
    }
    return false;
}


//-------------------------------------------
function updateMaskPosition() {
    /// <summary>
    /// Make sure the jquery tools mask is displayed
    /// immediately below the latest visible modal
    /// (popup) form. If no modal forms are visible,
    /// make sure the mask is hidden.
    /// </summary>
    var c = crumbsListEnd,
        $m = $.mask.getMask();
    if (!$m) { // make sure mask has been initialized
        $(document).mask({
            color: '#f0f0f0',
            opacity: 0.7,
            loadSpeed: 0,
            closeSpeed: 0,
            closeOnClick: false,
            closeOnEsc: false
        });
        $m = $.mask.getMask();
    }

    while (c) {
        if (c.zIndex) { break; }
        c = c.previous;
    }
    if (c) {
        $.mask.load();
        $m.css("z-index", c.zIndex - 1);
    } else {
        $.mask.close();
    }
}


/**
 * Detect changes to begin/end crumbs and indicate pending observable mutation.
 *
 * Must be called before "updateObservableCrumbs".
 *
 * @param newListBegin
 *     Crumb that will be set as crumbs.begin.
 * @param newListEnd
 *     Crumb that will be set as crumbs.end.
 * @returns
 *     True if either being/end will change; false otherwise.
 */
function preupdateObservableCrumbs(newListBegin, newListEnd) {
    var changed = false;
    var observableCrumbs = ko.unwrap(pli.forms.crumbs);
    if (observableCrumbs) {
        var beginChanged = !areCrumbsSame(observableCrumbs.begin, newListBegin);
        var endChanged = !areCrumbsSame(observableCrumbs.end, newListEnd);
        changed = beginChanged || endChanged;
        if (changed) {
            pli.forms.crumbs.valueWillMutate();
            observableCrumbs.beginChanged = beginChanged;
            observableCrumbs.begin = newListBegin;
            observableCrumbs.endChanged = endChanged;
            observableCrumbs.end = newListEnd;
            // Give subscribers a chance to react to new crumbs state
            // before actually changing the value.
            pli.forms.crumbs.notifySubscribers(observableCrumbs, "changing");
        }
    }
    return changed;
}


/**
 * Update observable crumbs if they are available and begin/end has changed.
 *
 * Must be called after "preupdateObservableCrumbs".
 *
 * @param changed
 *     True if begin/end has changed; false otherwise (return value
 *     from "preupdateObservableCrumbs").
 */
function updateObservableCrumbs(changed) {
    if (changed) {
        var observableCrumbs = ko.unwrap(pli.forms.crumbs);
        if (observableCrumbs) {
            pli.forms.crumbs.valueHasMutated();
        }
    }
}


//-------------------------------------------
function closeForm(formId) {
    /// <summary>
    /// Close the specified form (if active).
    /// Closing the root form will close the
    /// browser window as well.
    /// </summary>
    var closingNoHashForm,
        f = (typeof formId === "object" ? formId : pli.forms.registry[formId]),
        c = crumbsListEnd;

    // ensure requested form is active (shown)
    while (c) {
        if (c.page.form === f) { break; }
        c = c.previous;
    }
    if (!c) {
        return f; // not active, nothing to close
    }

    // closing the root form closes the whole window
    if (f.isRoot) {
        window.close();
        return f;
    }

    // cut the crumbs chain into two (crumbs that will remain active and crumbs that will be deactivated) + deactivate
    closingNoHashForm = !c.hash;
    c = c.previous;
    c.next.previous = null;
    c.next = null;
    deactivateNavigationCrumbs(crumbsListEnd, c);
    crumbsListEnd = c;
    updateMaskPosition();

    // now update URL (hash)
    if (closingNoHashForm) {
        pli.forms.onHashChange(); // will call updateObservableCrumbs()
    } else {
        while (c) {
            if (c.inLocationHash) {
                if (normalizeNavigationHash(null, true) !== normalizeNavigationHash(c.hash, true)) {
                    location.hash = c.hash; // will trigger onHashChange which will call updateObservableCrumbs()
                }
                break;
            }
            c = c.previous;
        }
    }
    crumbsListEnd.page.loadFocus();
    return f;
}


//-------------------------------------------
function openForm(formId, formData) {
    /// <summary>
    /// </summary>
    var h, // hash segment for the form being opened
        c,
        f = (typeof formId === "object" ? formId : pli.forms.registry[formId]), // form that is being opened
        lastActiveCrumb = crumbsListEnd,
        tailHash = null;

    formData = formData || {};
    if (!f || !f.page) { throw new Error("Unknown form \"".concat(formId, "\", unable to show")); }
    if (f.page.isDisabled) { throw new Error("Form \"".concat(f.id, "\" is disabled, unable to open")); }
    if (typeof formData !== "object") { throw new Error("Form data must be an object"); }

    // update crumb markers (if needed)
    if (formData.includeInHash && formData.replaceId) {
        c = lastActiveCrumb;
        while (c) {
            if (c.page.form === f) { break; }
            c = c.previous;
        }
        if (c) { // we found what to replace
            lastActiveCrumb = c.previous; // if we matched root form, lastActiveCrumb will be undefined now
            if (formData.replacePreservesCrumbsTail) {
                tailHash = c.hash.length;
                while (c.next && c.next.inLocationHash) {
                    c = c.next;
                }
                tailHash = c.hash.substring(tailHash);
            }
        }
    }

    // determine new hash segment for the form being shown
    h = (!lastActiveCrumb || lastActiveCrumb.page.defaultChildFormId === f.id
        ? crumbIdUtil.encode(formData.id)
        : f.id.concat(":", crumbIdUtil.encode(formData.id)));

    // initiate form showing
    if (formData.includeInHash) {
        if (isNoHashFormActive()) {
            if (window.console) { window.console.warn("A form that is not included in current hash is already open; can't open its child with includeInHash flag"); }
            return;
        }
        h = (lastActiveCrumb ? lastActiveCrumb.hash.concat("/") : "#").concat(h);
        if (tailHash) {
            h = h.concat(tailHash);
        }

        // changing hash (whether history is updated or not)
        // will trigger onHashChange that will trigger
        // activation that will show form
        if (formData.doNotUpdateHistory) {
            location.replace(location.href.substring(0, location.href.indexOf("#")).concat(h));
        } else {
            location.hash = h;
        }
    } else {
        c = {
            type: "PLI navigation crumb",
            page: f.page,
            data: {
                type: "PLI form data",
                form: f,
                value: formData
            },
            inLocationHash: false,
            hash: "",
            previous: crumbsListEnd
        };
        crumbsListEnd.next = c;
        var changed = preupdateObservableCrumbs(crumbsListBegin, c);
        activateNavigationCrumbs(c); // will show form
        crumbsListEnd = c;
        updateMaskPosition();
        updateObservableCrumbs(changed);
    }

    return f;
}


//-------------------------------------------
function resetActivationFocus() {
    var $found, crumb = crumbsListEnd;
    while (crumb) {
        $found = crumb.page.findActivationFocus();
        if ($found.length) {
            $found.focus();
            break;
        }
        crumb = crumb.previous;
    }
}


//-------------------------------------------
function onHashChange() {
    /// <summary>
    /// Triggered every time current page's
    /// location.hash changes (the part after '#', e.g.
    /// http://server/page#/hashSegmentA/hashSegmentB)
    /// </summary>
    var hash,
        hashSegments,
        current,
        deactivationBegin = null,
        deactivationEnd,
        explicitHash,
        activationBegin,
        newListBegin,
        newListEnd,
        created,
        i,
        h = "",
        d;

    // do not allow hash changes while at least one no-hash form is active
    if (isNoHashFormActive()) {
        return;
    }

    // find how far can we follow current crumbs list with the new hash
    hash = normalizeNavigationHash(null);
    hashSegments = hash.split('/');
    for (i = 0, current = crumbsListBegin; i < hashSegments.length && current; i += 1, current = current.next) {
        h = i ? h.concat("/", hashSegments[i]) : hashSegments[0];
        if (h.toLowerCase() !== current.hash.toLowerCase()) {
            break;
        }
        current.inLocationHash = true; // current crumb could have been created as a default but now it's in hash explicitly
    }
    if (current && current.previous) {
        activationBegin = null;
        newListBegin = crumbsListBegin;
        deactivationBegin = current;
        deactivationEnd = crumbsListEnd;
        current = current.previous;
        if (current.next) { // break the linked list
            current.next.previous = null;
            current.next = null;
        }
        if (current.data && current.data.next) { // also break the data linked list
            current.data.next.previous = null;
            current.data.next = null;
        }
    } else {
        if (!current && crumbsListEnd) { // we passed beyond the current crumbs list (in the for loop above the whole list matched current hash), let's reuse the whole list
            current = crumbsListEnd;
            activationBegin = null;
            newListBegin = crumbsListBegin;
            deactivationEnd = null;
        } else { // need to start from scratch
            d = {
                type: "PLI form data",
                form: rootForm,
                id: crumbIdUtil.decode(hashSegments[0].substr(1)) // ignore the leading '#' in the first hash segment
            };
            validateNavigationData(null, d); // try validating data for the root form, but even if validation fails (null return value) continue with crumb creation

            rewriteHrefs(rootForm.page, hashSegments[0]);
            activationBegin = newListBegin = current = {
                type: "PLI navigation crumb",
                page: rootForm.page,
                hash: hashSegments[0],
                inLocationHash: true,
                data: d
            };
            deactivationBegin = crumbsListBegin;
            deactivationEnd = crumbsListEnd;
            i = 1;
        }
    }

    // add crumbs that didn't exist in current crumbs list
    while (i < hashSegments.length) {
        created = createNavigationCrumb(hashSegments[i], current);
        if (!created) {
            break;
        }
        activationBegin = activationBegin || created;
        current = created;
        i += 1;
    }

    // add crumbs for default navigation pages (if any)
    created = createNavigationCrumb(null, current);
    if (created) {
        activationBegin = activationBegin || current.next;
        current = created;
    }
    newListEnd = current;

    // move deactivation/activation markers while
    // they point to equivalent crumbs
    while (true) {
        if (!areCrumbsValidAndEquivalent(deactivationBegin, activationBegin)) {
            break;
        }
        if (activationBegin.page.activationHash && (activationBegin.page.activationHash !== activationBegin.hash)) {
            // activationBegin won't be reactivated, but the page's activation hash needs updating
            rewriteHrefs(activationBegin.page, activationBegin.hash);
        }
        deactivationBegin = deactivationBegin.next;
        activationBegin = activationBegin.next;
    }
    if (deactivationBegin) {
        deactivationBegin.previous = null;
    } else {
        deactivationEnd = null;
    }

    // deactivate + activate now
    i = null;
    if (deactivationEnd) {
        i = deactivateNavigationCrumbs(deactivationEnd); // returns an array of active elements that have not yet been "consumed" by saveFocus
        current = (activationBegin && activationBegin.previous) || newListEnd;
        current.page.loadFocus(); // before activation begins (if any), give last already activated crumb a chance to load its focus
    }
    activateNavigationCrumbs(activationBegin, i);

    // navigate crumbs until finding first
    // hash that is explictly inLocationHash
    // (will result in root (#) if no other
    // hash is found)
    current = newListEnd;
    while (current && !current.inLocationHash) {
        current = current.previous;
    }
    explicitHash = current.hash;

    // update href for all anchors activating pages in the new list
    // (this is needed to preserve currently selected nested navigation
    // pages when switching their parent)
    current = newListBegin;
    while (current) {
        if (!current.page.disableHrefMemory && !(current.page.form && current.page.form.disableHrefMemory)) {
            current.page.$activatedBy.prop("href", explicitHash);
        }
        current = current.next;
    }

    // now set the new crumbs list as the current one
    crumbsListBegin = newListBegin;
    crumbsListEnd = newListEnd;
    var changed = preupdateObservableCrumbs(newListBegin, newListEnd);
    updateMaskPosition();
    updateObservableCrumbs(changed);
    // if (window.console) { window.console.log("(onHashChange) Crumbs: ", crumbsListBegin, crumbsListEnd); }
}


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


//-------------------------------------------
// Store information about navigation page
// (as specified in data-pli-navigation-page attribute
// plus runtime properties).
function NavigationPage(pageData, $page, id) {
    if (!(this instanceof NavigationPage)) { // allow instantiation without the 'new' keyword
        return new NavigationPage(pageData);
    }

    $.extend(this, pageData);
    this.id = id;
    this.$page = $page;
    this.children = [];
}


//-------------------------------------------
NavigationPage.prototype.type = "PLI navigation page";


//-------------------------------------------
// Enables this navigation page. If "value" is
// specified, truthy value will enable this
// page while falsy value will disable it.
// Triggers URL rewrite for this navigation
// page and all its descendant children pages.
NavigationPage.prototype.enable = function enablePage(value) {
    this.disable(!(value === undefined || value));
};


//-------------------------------------------
// Disables this navigation page. If "value" is
// specified, truthy value will disable this
// page while falsy value will enable it.
// Triggers URL rewrite for this navigation
// page and all its descendant children pages.
NavigationPage.prototype.disable = function disablePage(value) {
    var isDisabled = (value === undefined || value);
    this.isDisabled = isDisabled;
    if (this.activationHash) {
        rewriteHrefs(this, this.activationHash, isDisabled);
    }
    if (this.$activationIndicatedBy) {
        this.$activationIndicatedBy.toggleClass("disabled", isDisabled);
    }
};


//-------------------------------------------
NavigationPage.prototype.findActivationFocus = function findActivationFocusOnPage() {
    return this.$page.find(".focusOnActivate:visible:not(:disabled):not([readonly]):first");
};


//-------------------------------------------
NavigationPage.prototype.saveFocus = function savePageFocus(activeElements) {
    var i, l, $e;

    if (!activeElements) {
        activeElements = [$(document.activeElement)];
        if (lastActiveElement) {
            activeElements.push($(lastActiveElement));
        }
    }
    for (i = 0, l = activeElements.length; i < l; i += 1) {
        $e = activeElements[i];
        if ($e.closest(this.$page).length) { // if current focused (active) element is a child of this navigation page
            // if (window.console) { window.console.log("saveFocus for ", this.id, " is remembering: ", $e); }
            this.$focus = $e;
            activeElements = [];
            break;
        }
    }
    if (i === l) {
        // if (window.console) { window.console.log("saveFocus for ", this.id, " found nothing"); }
        this.$focus = null;
    }
    return activeElements;
};


//-------------------------------------------
NavigationPage.prototype.loadFocus = function loadPageFocus() {
    if (this.$focus) {
        // if (window.console) { window.console.log("loadFocus for ", this.id, " is restoring focus to: ", this.$focus); }
        this.$focus.focus();
    } else {
        var $f = this.findActivationFocus();
        // if (window.console) { window.console.log("loadFocus for ", this.id, " found activation focus ", $f); }
        $f.focus();
    }
};


//-------------------------------------------
NavigationPage.prototype.forgetFocus = function forgetPageFocus() {
    var i, l;
    // if (window.console) { window.console.log("forgetFocus for ", this.id); }
    this.$focus = null;
    for (i = 0, l = this.children.length; i < l; i += 1) {
        this.children[i].forgetFocus();
    }
};


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


//-------------------------------------------
// Store information about navigation form
// (as specified in data-pli-form attribute
// plus runtime properties).
function NavigationForm(formData, $form) {
    if (!(this instanceof NavigationForm)) { // allow instantiation without the 'new' keyword
        return new NavigationForm(formData, $form);
    }

    $.extend(this, formData);
    this.$form = $form;

    var page = new NavigationPage(null, $form, this.id);
    page.form = this;
    page.keymap = this.keymap || null;
    this.keymap = null; // we transferred the keymap (if any) property to the navigation page associated with this form
    page.isDisabled = !!this.isDisabled; // convert truthy/falsey value to boolean
    this.isDisabled = null; // we transferred the isDisabled (if any) flag to the navigation page associated with this form
    page.defaultChildFormId = this.defaultChildFormId || null;
    this.defaultChildFormId = null; // we transferred the defaultChildFormId (if any) string to the navigation page associated with this form

    this.page = navigationPages[this.id] = page; // associate the newly created page with this form and add it to page registry
}


//-------------------------------------------
NavigationForm.prototype.type = "PLI navigation form";


//-------------------------------------------
// Prevents "util/disposable.disposeObject" from entering an infinite loop.
//
// There is an infinite loop where every form points to
// its navigation page which points back to the form.
NavigationForm.prototype.dispose = function disposeNavigationForm() {
    return;
};


//-------------------------------------------
NavigationForm.prototype.open = function openNavigationForm(options) {
    return openForm(this, options);
};


//-------------------------------------------
NavigationForm.prototype.close = function closeNavigationForm() {
    return closeForm(this);
};


//-------------------------------------------
function addForm($form, data) {
    var form = data || $form.data("pliForm");
    if (typeof form !== "object") { throw new Error("Attribute data-pli-form must resolve to an object"); }
    form.id = form.id || $form.prop("id"); // if "id" is not specified in data-pli-form attribute, use HTML ID property
    if (typeof form.id !== "string") { throw new Error("Attribute data-pli-form must contain an object with string property 'id' or must belong to an element with HTML ID property"); }
    if (formsRegistry.hasOwnProperty(form.id)) { throw new Error("Form \"".concat(form.id, "\" is defined multiple times on this page")); }
    form = new NavigationForm(form, $form);
    formsRegistry[form.id] = form; // add newly created form to forms registry
    return form;
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// add all forms on this HTML page to forms registry (and create a navigation page for each form + find root form)
$("[data-pli-form]").each(function formApiInit() {
    var $form = $(this), form = addForm($form);
    if (!rootForm || form.isRoot) {
        if (rootForm) { rootForm.isRoot = null; } // remove isRoot flag from previously selected root form (if any)
        rootForm = form;
        rootForm.isRoot = true; // make sure root form has the flag set
    }
});
if (!rootForm) { throw new Error("No forms are defined on this HTML page"); }
// if (window.console) { window.console.log("Found root form \"".concat(rootForm.id, "\": "), rootForm); }


// add all navigation pages on this HTML page to navigation pages registry
$("[data-pli-navigation-page]").each(function navigationPageInit() {
    var $navigationPage = $(this),
        navigationPage = $navigationPage.data("pliNavigationPage");

    if (typeof navigationPage !== "object") { throw new Error("Attribute data-pli-navigation-page must resolve to an object"); }
    if (typeof navigationPage.name !== "string") { throw new Error("Attribute data-pli-navigation-page must resolve to an object with string property 'name'"); }
    if (typeof navigationPage.parentId !== "string") { throw new Error("Attribute data-pli-navigation-page must resolve to an object with string property 'parentId'"); }
    navigationPage = new NavigationPage(navigationPage, $navigationPage, navigationPage.parentId.concat("_", navigationPage.name));
    navigationPages[navigationPage.id] = navigationPage; // add newly created page to page registry
    $navigationPage.data("pliNavigationPage", navigationPage); // update element with fully realized NavigationPage data
});


// connect navigation pages via parentId
$.each(navigationPages, function navigationPageConnectParent() {
    if (this.parentId) {
        this.parent = navigationPages[this.parentId];
        if (!this.parent) { throw new Error("Unable to find navigation parent \"".concat(this.parentId, "\"")); }
        this.parent.children.push(this);
    }
});


// process initial hash and make sure we react to all
// subsequent hash changes once the page is ready
// (i.e. images & co. might not have finished downloading
// yet, but "meat" of the page is there (DOM, scripts) )
$(document).on("pliLoadedScripts", function onLoadedScripts() {
    $(".initiallyActive").removeClass("initiallyActive");
    onHashChange();
    $(window).on("hashchange", onHashChange);
}).mousedown(function onMouseDown() {
    lastActiveElement = document.activeElement;
});


// create and return export object that will become "Pli.forms"
module.exports = {
    getCurrentForm: getCurrentForm,
    resetActivationFocus: resetActivationFocus,
    add: addForm,
    close: closeForm,
    open: openForm,
    root: rootForm,

    // Collection of Pli forms indexed by form id
    // (All HTML elements with the "data-pli-form" attribute are added to this collection when this file is loaded.)
    registry: formsRegistry,
    navigationPages: navigationPages,
    onHashChange: onHashChange, // TODO: rename to "synchronizeHash" or something similar
    crumbs: ko.observable({ beginChanged: false, begin: null, endChanged: false, end: null }) // TODO: make observable read-only from outside
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms/Forms.js
// module id = 384
// module chunks = 49